export default "__VITE_ASSET__CAwWnmwa__"